import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/setting/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/setting/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/setting/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/door/setting/save', params, options);

export const update = (params, options) =>
  request.post('/api/door/setting/update', params, options);
